import {browser$} from '@/streams/browser';
import {filter, map, retry, shareReplay, switchMap} from 'rxjs';

export function loadJS(elementId, url) {
  return new Promise<void>((resolve, reject) => {
    if (document.getElementById(elementId)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = url;
    script.onload = () => resolve();
    script.onerror = (e) => reject(e);
    document.body.appendChild(script);
  });
}

export function loadCSS(elementId, url) {
  return new Promise<void>((resolve, reject) => {
    if (document.getElementById(elementId)) {
      resolve();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    link.onload = () => resolve();
    link.onerror = (e) => reject(e);
    document.head.appendChild(link);
  });
}

export function createLoadLibObservable({id, loadJs}) {
  return browser$.pipe(
    switchMap(loadJs),
    retry(4),
    map(() => (window as any)[id]),
    filter(Boolean),
    shareReplay(1)
  );
}
